module.exports = __webpack_public_path__ + "media/images/lead-f41f9fec27a0bbcbee4b6a5b228b86a9.png";